
export default function(isFirst, tags) {
    sessionStorage.setItem('preferred_skip_check', true);

    const tagRequestIds = {};
    // create new list of all new parentTags and childTags
    tags.forEach(t => {
        if(isFirst) {
            tagRequestIds[t.id()] = t.isForcedPreferred() || t.isPreferred();
        } else {
            tagRequestIds[t.id()] = t.isForcedPreferred() || false; // if this is not the first time skipping we hide new tags
        }
    });
    return new Promise(async (resolve, reject) => {
        try {
            const tagsSaveRequest = await app.request({
                url: `${app.forum.attribute('apiUrl')}/tags/preferred`,
                method: 'POST',
                body: {
                    preferredTags: tagRequestIds
                }
            });
            const payloadResponse = await app.store.pushPayload(tagsSaveRequest);
            return resolve(payloadResponse);
        } catch(e) {
            return reject(e);
        }

    });
}
